import { ArrowLeftOutlined, FileTextOutlined } from "@ant-design/icons"
import { Flex, Typography } from "antd"
import React, { useEffect } from "react"

import { generateDocumentTitle } from "../../../constants/document-title.ts"

const { Title, Text } = Typography

export function ProposalsPage() {
  useEffect(() => {
    generateDocumentTitle("Proposal Review")
  }, [])

  return (
    <Flex
      vertical
      gap="middle"
      flex={1}
      align="center"
      justify="center"
      className="min-h-[400px] p-8"
    >
      <div className="w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center mb-2">
        <FileTextOutlined className="text-4xl" />
      </div>

      <Title level={4} className="!mb-1 text-center">
        Select a proposal
      </Title>

      <Text type="secondary" className="text-center max-w-xs">
        Choose proposal from the list on the left to view details
      </Text>

      <Flex align="center" gap="small" className="mt-4 text-gray-400">
        <ArrowLeftOutlined />
        <Text type="secondary" className="text-sm">
          Proposals are listed in the sidebar
        </Text>
      </Flex>
    </Flex>
  )
}
